import { render } from "./UserCategoriesSpending.vue?vue&type=template&id=366dd3db"
import script from "./UserCategoriesSpending.vue?vue&type=script&lang=js"
export * from "./UserCategoriesSpending.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserCategoriesSpending.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "366dd3db"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('366dd3db', __exports__)) {
    api.reload('366dd3db', __exports__)
  }
  
  module.hot.accept("./UserCategoriesSpending.vue?vue&type=template&id=366dd3db", () => {
    api.rerender('366dd3db', render)
  })

}


export default __exports__